/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/Nvl';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Flows from './coms/Flows';

const propTypes = {
  appState: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  planState: React.PropTypes.object.isRequired,
};

class FlowsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appState: props.appState,
      planState: props.planState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.flowsview');
  }

  componentWillReceiveProps(nextProps) {
    const { appState, planState } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
    if (planState !== this.props.planState) {
      this.setState({ planState });
    }
  }

  renderToolbar() {
    const { pushState, appId } = this.props;
    const { appState } = this.state;
    const { status, data: { name } = {} } = appState;

    const addButton = (
      <Button bsStyle="aisz-success" onClick={() => pushState(`/application/${appId}/flows/add`)}>
        {this.intlMsg.msg('add')}{' '}<span className="halflings halflings-plus" />
      </Button>
    );

    const breadcrumb = [{
      content: this.intlMsg.globalMsg('application.breadcrumb.application'),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl status={status} val={name} />,
      active: true,
    }];

    return <Toolbar breadcrumb={breadcrumb} rightTools={[{ input: addButton }]} />;
  }

  render() {
    const { appId } = this.props;
    const { planState } = this.state;
    if (planState.status === 'pending') {
      return <PageLoading />;
    }
    if (planState.data.tier === 1) {
      return <PageNoPerm />;
    }
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Flows appId={appId} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

FlowsView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appState: state.app.getApp,
  appId: ownProps.params.id,
  planState: state.billing.plan,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(FlowsView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/index.jsx